export default function Contact() {
  return (
    <section id="contact" className="bg-white py-32">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="font-serif text-[42px] text-black mb-5">お問い合わせ</h2>
          <div className="w-20 h-px bg-[#2C2C2C] mx-auto mb-12" />
          
          <p className="text-[16px] text-[#2C2C2C] leading-[1.9] mb-16">
            バケーションレンタル事業に関するご相談、サービスの詳細についてのお問い合わせは、
            <br />
            お電話またはメールにて承っております。お気軽にご連絡ください。
          </p>

          <div className="grid grid-cols-2 gap-12 mb-16">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className="ri-phone-line text-[48px] text-[#1A3A52]" />
              </div>
              <div className="text-[14px] text-[#666666] mb-3">お電話でのお問い合わせ</div>
              <div className="text-[28px] font-bold text-black mb-2">03-1234-5678</div>
              <div className="text-[14px] text-[#666666]">平日 9:00 - 18:00</div>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className="ri-mail-line text-[48px] text-[#1A3A52]" />
              </div>
              <div className="text-[14px] text-[#666666] mb-3">メールでのお問い合わせ</div>
              <div className="text-[20px] font-medium text-black mb-2">info@vacation-rental.co.jp</div>
              <div className="text-[14px] text-[#666666]">24時間受付</div>
            </div>
          </div>

          <a
            href="#"
            className="inline-block px-12 py-4 bg-[#1A3A52] text-white text-[16px] font-medium rounded-md hover:bg-[#2C4A62] transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            お問い合わせフォームへ
          </a>
        </div>
      </div>
    </section>
  );
}
